import { adminHttpClient } from '../../../commons/adminHttpClient'
import { Moment } from 'moment'

export interface RenewalNotificationInfo {
  adminFirstName: string
  currentPlanEndDate: Moment
  autoLaunchDate: Moment
  newPlanStartDate: Moment
}

export const getRenewalNotification = (): Promise<any> => {
  return adminHttpClient.get('/AdminDashboard/RenewalNotification')
}
